import React, { useState, useEffect } from "react";

const TIPURI_ACTIUNI = [
  { value: "Inscriere membru nou", label: "Înscriere membru nou (200 puncte)", points: 200 },
  { value: "Plată cotizație simpatizant", label: "Plată cotizație membru simpatizant (1 punct)", points: 1 },
  { value: "Plată cotizație membru cotizant", label: "Plată cotizație membru cotizant (50 puncte)", points: 50 },
  { value: "Donatie", label: "Donație (puncte după sumă)", points: 0 },
  { value: "Finalizare curs", label: "Finalizare curs (20 puncte)", points: 20 },
  { value: "Participare eveniment", label: "Participare eveniment (50 puncte)", points: 50 },
  { value: "Alt motiv", label: "Alt motiv (punctaj personalizat)", points: 0 },
];

export default function AtribuirePuncte() {
  const [membri, setMembri] = useState([]);
  const [selectedMembru, setSelectedMembru] = useState("");
  const [tipActiune, setTipActiune] = useState("");
  const [puncte, setPuncte] = useState("");
  const [detalii, setDetalii] = useState("");
  const [donatieSuma, setDonatieSuma] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    async function fetchMembri() {
      try {
        const res = await fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
          headers: {
            Authorization: "Bearer unwantedtok",
          },
        });
        if (!res.ok) throw new Error("Eroare la încărcarea membrilor");
        const data = await res.json();
        setMembri(data);
      } catch (err) {
        setError(err.message);
      }
    }
    fetchMembri();
  }, []);

  // Actualizare puncte automat când tipul acțiunii se schimbă (acum corect cu Donatie și Alt motiv)
  useEffect(() => {
    if (tipActiune === "Donatie" || tipActiune === "Alt motiv") {
      setPuncte("");
    } else {
      const act = TIPURI_ACTIUNI.find((a) => a.value === tipActiune);
      setPuncte(act ? act.points.toString() : "");
      setDonatieSuma("");
    }
  }, [tipActiune]);

  // Calculează puncte pentru donație: 1 punct la fiecare 1 lei donați
  useEffect(() => {
    if (tipActiune === "Donatie" && donatieSuma) {
      const sumaNr = Number(donatieSuma);
      if (!isNaN(sumaNr) && sumaNr >= 1) {
        setPuncte(Math.floor(sumaNr / 1).toString());
      } else {
        setPuncte("");
      }
    }
  }, [donatieSuma, tipActiune]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccessMsg("");
    if (!selectedMembru) {
      setError("Alege un membru");
      return;
    }
    if (!tipActiune) {
      setError("Alege un tip de acțiune");
      return;
    }
    if (!puncte || Number(puncte) <= 0) {
      setError("Punctele trebuie să fie un număr pozitiv");
      return;
    }

    setLoading(true);
    try {
      const timestampNow = new Date().toISOString();

      const payload = {
        id_membru: selectedMembru,
        puncte: Number(puncte),
        action_type: tipActiune,
        details: detalii.trim(),
        operator_id: "admin-bn", // poate fi preluat din contextul autentificării
        timestamp: timestampNow,
      };

      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/atribui-puncte", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer unwantedtok",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Eroare la atribuirea punctelor");

      setSuccessMsg("Punctele au fost atribuite cu succes!");
      // Reset formular
      setSelectedMembru("");
      setTipActiune("");
      setPuncte("");
      setDetalii("");
      setDonatieSuma("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <h3>Atribuire puncte</h3>
      {error && <div className="alert alert-danger">{error}</div>}
      {successMsg && <div className="alert alert-success">{successMsg}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Membru:</label>
          <select
            className="form-select"
            value={selectedMembru}
            onChange={(e) => setSelectedMembru(e.target.value)}
            required
          >
            <option value="">-- Alege membru --</option>
            {membri.map((m) => (
              <option key={m.id} value={m.id}>
                {m.prenume} {m.nume}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label>Tip acțiune:</label>
          <select
            className="form-select"
            value={tipActiune}
            onChange={(e) => setTipActiune(e.target.value)}
            required
          >
            <option value="">-- Alege tip acțiune --</option>
            {TIPURI_ACTIUNI.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>

        {tipActiune === "Donatie" && (
          <div className="mb-3">
            <label>Suma donației (lei):</label>
            <input
              type="number"
              min="1"
              className="form-control"
              value={donatieSuma}
              onChange={(e) => setDonatieSuma(e.target.value)}
              required
            />
            <small className="form-text text-muted">
              Punctele se calculează: 1 punct la fiecare 1 leu donați.
            </small>
          </div>
        )}

        <div className="mb-3">
          <label>Puncte atribuite:</label>
          <input
            type="number"
            className="form-control"
            value={puncte}
            readOnly={tipActiune !== "Donatie" && tipActiune !== "Alt motiv"}
            onChange={(e) => setPuncte(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Detalii (opțional):</label>
          <textarea
            className="form-control"
            value={detalii}
            onChange={(e) => setDetalii(e.target.value)}
            rows={3}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Se atribuie..." : "Atribuie puncte"}
        </button>
      </form>
    </div>
  );
}
